import {FC, useMemo} from 'react'
import {buildContentStoryEvents} from '../buildContentStory'
import {buildPrintFlowOutcome} from '../printFlow/outcomeModel'
import {PrintStoryDoc} from '../types'
import {CodeGroups} from './CodeGroups'
import {ExpectedObservedSummary} from './ExpectedObservedSummary'
import {OperationalStageFlow} from './OperationalStageFlow'
import {PrintFlowOutcomeBanner} from './PrintFlowOutcomeBanner'
import {PrinterDeliveryMatrix} from './PrinterDeliveryMatrix'
import {SemanticTimeline} from './SemanticTimeline'

type Props = {
  content?: PrintStoryDoc | null
  codes?: PrintStoryDoc[]
  renderJobs?: PrintStoryDoc[]
  printJobs?: PrintStoryDoc[]
  printerStatuses?: PrintStoryDoc[]
  printerConnections?: PrintStoryDoc[]
  callbackLogs?: PrintStoryDoc[]
  commandLogs?: PrintStoryDoc[]
  mishaps?: PrintStoryDoc[]
  emails?: string[]
  onOpenJson?: () => void
}

export const PrintFlowPanel: FC<Props> = ({
  content,
  codes = [],
  renderJobs = [],
  printJobs = [],
  printerStatuses = [],
  printerConnections = [],
  callbackLogs = [],
  mishaps = [],
  emails = [],
  onOpenJson,
}) => {
  const outcome = useMemo(
    () =>
      buildPrintFlowOutcome({
        content,
        codes,
        renderJobs,
        printJobs,
        printerStatuses,
        printerConnections,
        callbackLogs,
        emails,
      }),
    [
      content,
      codes,
      renderJobs,
      printJobs,
      printerStatuses,
      printerConnections,
      callbackLogs,
      emails,
    ]
  )

  const storyEvents = useMemo(
    () =>
      buildContentStoryEvents({
        content,
        codes,
        renderJobs,
        printJobs,
        mishaps,
        includeSecondaryLogs: false,
      }),
    [content, codes, renderJobs, printJobs, mishaps]
  )

  return (
    <div>
      <PrintFlowOutcomeBanner outcome={outcome} />
      <ExpectedObservedSummary outcome={outcome} />
      <OperationalStageFlow outcome={outcome} />
      <CodeGroups outcome={outcome} />
      <PrinterDeliveryMatrix outcome={outcome} />
      <SemanticTimeline
        outcome={outcome}
        storyEvents={storyEvents}
        printJobs={printJobs}
        mishaps={mishaps}
        onOpenJson={onOpenJson}
      />
    </div>
  )
}
